export default {
  state: {
    //Variables que almacenan la coleccion de datos que vienen del servidor
    datacollectionMod1:null,
    datacollectionMod2:null,

    //Variables que indican si existieron cambios en las colecciones de datos (se daran cuando es exitosa la consulta)
    dataCollectionCambio1:null,
    dataCollectionCambio2:null,

    //Variables que almacenan el json de consulta para ver numero de pacientes
    jsonRegistro:null,
    jsonGestion:null,

    //Variables que indican si existieron cambios en los filtros para consulta de pacientes
    jsonRegistroCambio:null,
    jsonGestionCambio:null

  },
  getters: {
    getDataCollectionMod1: state => state.datacollectionMod1,
    getDataCollectionMod2: state => state.datacollectionMod2,

    getJsonRegistro: state => state.jsonRegistro,
    getJsonGestion: state => state.jsonGestion,

    getJsonRegistroCambio: state => state.jsonRegistroCambio,
    getJsonGestionCambio: state => state.jsonGestionCambio,

    getDataCollectionCambio1: state => state.dataCollectionCambio1,
    getDataCollectionCambio2: state => state.dataCollectionCambio2,
  },
  mutations: {
    //
    setDataCollectionMod1(state, data){
      state.datacollectionMod1 = data
    },
    setDataCollectionMod2(state, data){
      state.datacollectionMod2 = data
    },

    //
    setDataCollectionCambio1(state, data){
      state.dataCollectionCambio1 = data
    },
    setDataCollectionCambio2(state, data){
      state.dataCollectionCambio2 = data
    },

    //
    setJsonRegistro(state, data){
      state.jsonRegistro = data
    },
    setJsonGestion(state, data){
      state.jsonGestion = data
    },

    //
    setJsonRegistroCambio(state, data){
      state.jsonRegistroCambio = data
    },
    setJsonGestionCambio(state, data){
      state.jsonGestionCambio = data
    }
  },
  actions: {
    //
    setDataCollectionMod1(context,data){
      context.commit("setDataCollectionMod1", data);
    },
    setDataCollectionMod2(context,data){
      context.commit("setDataCollectionMod2", data);
    },

    //
    setDataCollectionCambio1(context,data){
      context.commit("setDataCollectionCambio1",data)
    },    
    setDataCollectionCambio2(context,data){
      context.commit("setDataCollectionCambio2",data)
    },

    //
    setJsonRegistro(context,data){
      context.commit("setJsonRegistro", data)
    },
    setJsonGestion(context,data){
      context.commit("setJsonGestion", data)
    },

    //
    setJsonRegistroCambio(context,data){
      context.commit("setJsonRegistroCambio",data)
    },
    setJsonGestionCambio(context,data){
      context.commit("setJsonGestionCambio",data)
    },
  },
};



// WEBPACK FOOTER //
// ./src/js/modules/ControlPanel.js